
import { app } from "../serviceLMS";
import { GET_ROLE, GET_USER_HISTORY_FILTER_OPTIONS } from "../URLs";

export const getUserDeadlines = async (days, userId) => {
  try {
    const response = await app.get('user/api/client-api/admin/user-deadlines', {
      params: { days, userId }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getUserReportFilterOptions = async (userId) => {
  try {
    const response = await app.get(`${GET_USER_HISTORY_FILTER_OPTIONS}${userId}/filter-options`);
    return response.data.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getUserReport = async (userId, params = {}) => {
  try {
    const response = await app.get(`user/api/client-api/reports/user/${userId}`, {
      params: {
        page: params.page ?? 0,
        size: params.size ?? 10,
        sortDir: params.sortDir || "DESC",
        search: params.search || undefined,
        filterType: params.filterType || undefined, 
        subType: params.subType || undefined,
        status: params.status || undefined,
        groupId: params.groupId || undefined,
        courseId: params.courseId || undefined,
        bundleId: params.bundleId || undefined,
        enrollmentStatus: params.enrollmentStatus || undefined,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const downloadUserReport = async (userId) => {
  try {
    const response = await app.get(`user/api/client-api/reports/user/${userId}/download`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `user_report_${userId}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    throw new Error(error?.response?.data?.message || "Download failed");
  }
};

export const getAllRoles = async()=> {
  try {
    const response = await app.get(GET_ROLE);
    if(response.status===200){
      return {success: true, resp: response?.data}
    }
    else {
      return {success: false, message: response.data.message}
    }


  } catch(error){
    console.log(error);
    return {success: false, message: error?.data?.message};
  }
}
